export const makeModelData = [
  {
    make: "Acura",
    models: ["ILX", "Integra", "TLX", "RLX", "RDX", "MDX", "ZDX"]
  },
  {
    make: "Alfa Romeo",
    models: ["Giulia", "Stelvio", "Tonale"]
  },
  {
    make: "Audi",
    models: ["A3", "S3", "RS 3", "A4", "S4", "A5", "S5", "RS 5", "A6", "S6", "RS 6 Avant", "A7", "S7", "RS 7", "A8", "S8", "Q3", "Q4 e-tron", "Q5", "SQ5", "Q7", "Q8", "e-tron", "Q8 e-tron", "TT", "R8", "e-tron GT"]
  },
  {
    make: "BMW",
    models: ["2 Series", "3 Series", "M3", "4 Series", "M4", "5 Series", "M5", "7 Series", "8 Series", "M8", "i3", "i4", "i5", "i7", "iX", "X1", "X2", "X3", "X4", "X5", "X6", "X7", "Z4"]
  },
  {
    make: "Buick",
    models: ["Encore", "Encore GX", "Envision", "Enclave", "Regal", "LaCrosse", "Verano"]
  },
  {
    make: "Cadillac",
    models: ["CT4", "CT5", "CT6", "XTS", "ATS", "CTS", "Escalade", "Escalade ESV", "XT4", "XT5", "XT6", "LYRIQ", "CELESTIQ"]
  },
  {
    make: "Chevrolet",
    models: ["Spark", "Sonic", "Cruze", "Malibu", "Impala", "Camaro", "Corvette", "Trax", "Trailblazer", "Equinox", "Blazer", "Traverse", "Tahoe", "Suburban", "Colorado", "Silverado 1500", "Silverado HD", "Bolt EV", "Bolt EUV", "Express"]
  },
  {
    make: "Chrysler",
    models: ["200", "300", "Pacifica", "Voyager"]
  },
  {
    make: "Dodge",
    models: ["Dart", "Charger", "Challenger", "Durango", "Journey", "Hornet"]
  },
  {
    make: "Fiat",
    models: ["500", "500X", "500L", "124 Spider"]
  },
  {
    make: "Ford",
    models: ["Fiesta", "Focus", "Fusion", "Mustang", "Mustang Mach-E", "Taurus", "Escape", "Edge", "Bronco", "Bronco Sport", "Explorer", "Expedition", "EcoSport", "Maverick", "Ranger", "F-150", "F-250", "F-350", "Transit", "Transit Connect", "F-150 Lightning"]
  },
  {
    make: "Genesis",
    models: ["G70", "G80", "G90", "GV60", "GV70", "GV80"]
  },
  {
    make: "GMC",
    models: ["Terrain", "Acadia", "Yukon", "Yukon XL", "Canyon", "Sierra 1500", "Sierra HD", "Hummer EV"]
  },
  {
    make: "Honda",
    models: ["Fit", "Civic", "Accord", "Insight", "HR-V", "CR-V", "Passport", "Pilot", "Ridgeline", "Odyssey", "Prologue"]
  },
  {
    make: "Hyundai",
    models: ["Accent", "Elantra", "Sonata", "Ioniq", "Ioniq 5", "Ioniq 6", "Veloster", "Venue", "Kona", "Kona EV", "Tucson", "Santa Fe", "Palisade", "Santa Cruz", "Nexo"]
  },
  {
    make: "Infiniti",
    models: ["Q50", "Q60", "Q70", "QX30", "QX50", "QX55", "QX60", "QX70", "QX80"]
  },
  {
    make: "Jaguar",
    models: ["XE", "XF", "XJ", "F-Pace", "E-Pace", "I-Pace", "F-Type"]
  },
  {
    make: "Jeep",
    models: ["Renegade", "Compass", "Cherokee", "Grand Cherokee", "Wrangler", "Wrangler 4xe", "Gladiator", "Wagoneer", "Grand Wagoneer"]
  },
  {
    make: "Kia",
    models: ["Rio", "Forte", "K5", "Optima", "Stinger", "Soul", "Seltos", "Sportage", "Sorento", "Telluride", "Carnival", "EV6", "EV9", "Niro"]
  },
  {
    make: "Land Rover",
    models: ["Range Rover", "Range Rover Sport", "Range Rover Velar", "Range Rover Evoque", "Discovery", "Discovery Sport", "Defender"]
  },
  {
    make: "Lexus",
    models: ["IS", "ES", "GS", "LS", "UX", "NX", "RX", "GX", "LX", "RZ"]
  },
  {
    make: "Lincoln",
    models: ["MKZ", "MKS", "Continental", "Corsair", "Nautilus", "Aviator", "Navigator"]
  },
  {
    make: "Mazda",
    models: ["Mazda3", "Mazda6", "CX-3", "CX-30", "CX-5", "CX-50", "CX-9", "CX-90", "MX-30", "MX-5 Miata"]
  },
  {
    make: "Mercedes-Benz",
    models: ["A-Class", "C-Class", "E-Class", "S-Class", "CLA", "CLS", "GLA", "GLB", "GLC", "GLE", "GLS", "G-Class", "EQB", "EQE", "EQS", "SL"]
  },
  {
    make: "Mini",
    models: ["Cooper", "Clubman", "Countryman", "Electric SE"]
  },
  {
    make: "Mitsubishi",
    models: ["Mirage", "Lancer", "Outlander", "Outlander Sport", "Eclipse Cross"]
  },
  {
    make: "Nissan",
    models: ["Versa", "Sentra", "Altima", "Maxima", "Leaf", "370Z", "Z", "GT-R", "Kicks", "Rogue", "Murano", "Pathfinder", "Armada", "Frontier", "Titan", "Ariya"]
  },
  {
    make: "Porsche",
    models: ["718 Cayman", "718 Boxster", "911", "Panamera", "Macan", "Cayenne", "Taycan"]
  },
  {
    make: "Ram",
    models: ["1500", "1500 Classic", "2500", "3500", "ProMaster", "ProMaster City"]
  },
  {
    make: "Subaru",
    models: ["Impreza", "WRX", "Legacy", "Crosstrek", "Forester", "Outback", "Ascent", "Solterra"]
  },
  {
    make: "Tesla",
    models: ["Model 3", "Model S", "Model X", "Model Y", "Cybertruck"]
  },
  {
    make: "Toyota",
    models: ["Yaris", "Corolla", "Corolla Cross", "Camry", "Avalon", "Prius", "Prius Prime", "Mirai", "GR Supra", "GR86", "C-HR", "RAV4", "Venza", "Highlander", "Grand Highlander", "4Runner", "Sequoia", "Sienna", "Tacoma", "Tundra", "bZ4X"]
  },
  {
    make: "Volkswagen",
    models: ["Golf", "Golf GTI", "Golf R", "Jetta", "Jetta GLI", "Passat", "Arteon", "Beetle", "ID.4", "Taos", "Tiguan", "Atlas", "Atlas Cross Sport"]
  },
  {
    make: "Volvo",
    models: ["S60", "S90", "V60", "V90", "XC40", "XC40 Recharge", "C40 Recharge", "XC60", "XC90", "EX30", "EX90"]
  }
];

export default makeModelData;
